export default "__VITE_ASSET__CW6KA53l__"